import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../../modules/order-details';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { escapeODataStringLiteral } from '../../utilities/odata';

/**
 * GetServiceContacts Input Action
 */
export class GetServiceContactsInput implements Msdyn365.IActionInput {
    public userToken: string;

    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetServiceContacts-${this.userToken}`;
    public getCacheObjectType = () => 'GetServiceContacts';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetServiceContactsData {
    '@odata.context'?: string;
    value: IServiceContacts[];
    error?: ErrorCode;
}
export interface IServiceContacts {
    PartnerId: string;
    Name: string;
    Email: string;
    Role: string;
    RecordCreatedDate: string;
    ExtensionProperties: any[];
    SalesAreas: IServiceContactSalesArea[];
}

export interface IServiceContactSalesArea {
    SalesOrg: string;
    SalesOrgText: string;
    DistributionChannel: string;
    DistributionChannelText: string;
    Division: string;
    DivisionText: string;
    RecordCreatedDate: string;
    ExtensionProperties: any[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetServiceContactsInput(args);
};

async function action(_: GetServiceContactsInput, ctx: Msdyn365.IActionContext): Promise<IGetServiceContactsData> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetServiceContactsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetServicePartners(language='${escapeODataStringLiteral(
            ctx.requestContext.locale
        )}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { ...response.data };
    }
    return { ...({} as IGetServiceContactsData), error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetServiceContactsData>>action,
    id: 'GetServiceContacts',
    input: createInput
});
